export enum FedopsInteraction {
  CategoryClick = 'categoryClick',
  FirstPresetSectionLoad = 'new_add_panel_first_preset_section_load',
  TabChange = 'tabChange',
}
